import React from 'react'

export const Customers = () => {
  return (
    <div>Customers</div>
  )
}
